import React from 'react'
import { FeaturedLayout } from '../../layouts'
import DashboardTab from './DashboardTab'
import { useTemporadaActiva } from './useTemporadaActiva'
import TemporadaSelector from './TemporadaSelector'

const PagosDashboard = () => {
  const { temporadaId, temporadas, setTemporadaId } = useTemporadaActiva()

  return (
    <FeaturedLayout
      title="Resumen de cobranza"
      subtitle="Estado de la cobranza de la temporada seleccionada"
    >
      <DashboardTab
        temporadaId={temporadaId}
        temporadaSelector={<TemporadaSelector temporadas={temporadas} value={temporadaId} onChange={setTemporadaId} />}
      />
    </FeaturedLayout>
  )
}

export default PagosDashboard
